<template>
  <div>
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-col :span="12">
          <el-input style="width:200px;" size="mini"
                    placeholder="请输入名称查询"
                    prefix-icon="el-icon-search"
                    v-model="searchdata">
          </el-input>
        </el-col>
      </el-col>
    </div>
    <el-table
      :data="tableData.filter(data => (!searchdata ||!data.dname || data.dname.toLowerCase().includes(searchdata.toLowerCase())))"
      size="mini"
      stripe
      border
      style="width: 100%;">
      <el-table-column
        width="60"
        label="序号"
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index}}
        </template>
      </el-table-column>
      <el-table-column
        prop="dname"
        label="门店名称"  width="200"
        align="center" header-align="center">
      </el-table-column>
      <el-table-column
        prop="tel"
        label="联系电话"  width="100"
        align="center" header-align="center">
      </el-table-column>
      <!--<el-table-column-->
        <!--prop="businesshours"-->
        <!--label="营业时间"  width="100"-->
        <!--align="center" header-align="center">-->
      <!--</el-table-column>-->
      <el-table-column
        prop="address"
        label="地址"
        header-align="center"
        align="left">
      </el-table-column>
      <el-table-column
        width="200"
        label="状态"
        align="center">
        <template slot-scope="scope">
          <el-button type="info" plain disabled v-if="scope.row.showindex==0" size="mini">未签约</el-button>
          <el-button type="success"  v-if="scope.row.showindex==1" size="mini" @click="sineShow(scope.row)">已签约</el-button>
          <el-button type="primary"  v-if="scope.row.showindex==2" size="mini" @click="sineIn(scope.row)">签 约</el-button>
        </template>
      </el-table-column>
    </el-table>
    <ExternaldeptEdit ref="ExternaldeptEdit1" @AfterSave="AfterSave"></ExternaldeptEdit>
  </div>
</template>
<script>
  import {listlaoxianAllStore} from '@/api/set/dept';
  import {empower, listempower} from '@/api/ossi';
  import ExternaldeptEdit from '@/components/set/externaldept/ExternaldeptEdit';

  export default {
    name: 'storelist',
    data() {
      return {
        msg: '查看门店的页面',
        searchdata: "",
        tableData: [],
        powerData:[],
        setRow:{},
      }
    },
    methods: {
      sineIn(row) {
        this.$refs.ExternaldeptEdit1.initForm()
        this.$refs.ExternaldeptEdit1.show(['1']);
        this.$refs.ExternaldeptEdit1.initstoredata(row);
        this.setRow=row.power;
      },
      sineShow(row) {
        this.setRow = null;
        this.$refs.ExternaldeptEdit1.show(['1']);
        this.$refs.ExternaldeptEdit1.initData(row.power.toserial, true);
      },
      AfterSave(formdata,unitguid) {
        if (this.setRow == null) {
          this.$refs.ExternaldeptEdit1.closePage();
          return;
        }
        empower({
          toserial: unitguid,
          idencode: this.setRow.idencode,
          title: formdata.customerserial + ' ' + formdata.deptname
        }).then(response => {
          this.$refs.ExternaldeptEdit1.closePage();
          this.bindGrid();
        }).catch((error) => {
        });
      },
      //绑定分页参数
      bindGrid() {
        listlaoxianAllStore().then(response => {
          var rowd = response.data.obj;

          for (let j in rowd) {
            rowd[j].showindex = 0;
          }

          listempower().then(resPower => {
            this.powerData = resPower.data.obj;
            for (let i in this.powerData) {
              for (let j in rowd) {
                if (rowd[j].power) continue;
                if (rowd[j].tenantid == this.powerData[i].fromtenantid) {
                  rowd[j].power = this.powerData[i];
                  rowd[j].showindex = (this.powerData[i].toserial) ? 1 : 2;
                  console.log(rowd[j].showindex);
                  break;
                }
              }
            }

            rowd.sort(function (a, b) {
              if (a.showindex == b.showindex)
                return a.dname.localeCompare(b.dname);
              else
                return a.showindex < b.showindex ? 1 : -1;
            })
            this.tableData = rowd;
          })
        }).catch((error) => {
          console.log(error)
        });
      }
    },
    mounted() {
      this.bindGrid();
    },
    components: {
      ExternaldeptEdit
    }
  }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/workflow/waitaudit/LXstoreList.vue